import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import { getAbbreviatedUnit } from 'helpers/unitsAbbreviation';
import { emptyValue } from 'screens/ProductList/helpers/tableConstants';
import InfoIcon from 'assets/info.svg?react';
import getProductQuantity from 'screens/ProductList/helpers/getProductQuantity';
import useUomConvert from 'hooks/useUomConvert';

const ProductListCellQuantity = ({ product }) => {
  const convertFn = useUomConvert();
  const availableQuantity = getProductQuantity(product, convertFn);
  const unit = getAbbreviatedUnit(product.stdPackageUnit);
  return (
    <div className="w-full flex flex-row justify-start">
      <p>
        {product.productQuantityValue || product.purchased ? (
          <>
            <span>{availableQuantity}</span>{' '}
            <span>
              {availableQuantity !== emptyValue.dashLine ? unit : null}
            </span>
          </>
        ) : (
          emptyValue.none
        )}
      </p>
      {availableQuantity < 0 ? (
        <Tooltip
          color="#232630"
          placement="topLeft"
          overlayStyle={{ maxWidth: 'none' }}
          title={
            <div className="w-356px text-xs text-white">
              Add product quantity via invoices to resolve negative value
            </div>
          }
        >
          <div className="pl-3" data-testid="negative-quantity-info">
            <InfoIcon />
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
};

ProductListCellQuantity.propTypes = {
  product: PropTypes.shape({
    stdPackageUnit: PropTypes.string,
    purchased: PropTypes.number,
    productQuantityValue: PropTypes.number
  }).isRequired
};

export default ProductListCellQuantity;
